import { useState } from 'react';

export default function Styles() {
  const [activeFilter, setActiveFilter] = useState('Todos');

  const filters = ['Todos', 'Minimalista', 'Corporativo', 'Moderno', 'Elegante', 'Creativo', 'Juvenil', 'Premium'];

  const styles = [
    {
      id: 1,
      name: 'Minimalista',
      description: 'Diseños limpios, simples y elegantes',
      image: 'https://public.readdy.ai/ai/img_res/fd84bbaec0843c950e26feebe14642eb.jpg',
      icon: 'ri-contrast-2-line'
    },
    {
      id: 2,
      name: 'Corporativo',
      description: 'Profesional y confiable para empresas',
      image: 'https://readdy.ai/api/search-image?query=corporate%20professional%20business%20logo%20design%20with%20strong%20typography%2C%20navy%20blue%20and%20gold%20colors%2C%20executive%20branding%20materials%2C%20formal%20elegant%20style%2C%20clean%20office%20aesthetic%2C%20trustworthy%20business%20identity%2C%20premium%20corporate%20look%2C%20simple%20beige%20background&width=500&height=400&seq=style-corporate-001&orientation=landscape',
      icon: 'ri-building-line'
    },
    {
      id: 3,
      name: 'Moderno',
      description: 'Tendencias actuales y vanguardistas',
      image: 'https://readdy.ai/api/search-image?query=modern%20contemporary%20logo%20design%20with%20bold%20gradients%2C%20vibrant%20colors%2C%20dynamic%20shapes%2C%20trendy%20geometric%20patterns%2C%20fresh%20innovative%20style%2C%20cutting%20edge%20branding%2C%20sleek%20digital%20aesthetic%2C%20tech%20inspired%20elements%2C%20clean%20white%20background%20highlighting%20modern%20design&width=500&height=400&seq=style-modern-001&orientation=landscape',
      icon: 'ri-flashlight-line'
    },
    {
      id: 4,
      name: 'Elegante',
      description: 'Sofisticado y refinado',
      image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20logo%20design%20with%20gold%20foil%20accents%2C%20sophisticated%20serif%20typography%2C%20refined%20ornamental%20details%2C%20premium%20high%20end%20branding%2C%20classy%20timeless%20style%2C%20upscale%20boutique%20aesthetic%2C%20delicate%20decorative%20elements%2C%20soft%20cream%20background%20emphasizing%20elegance&width=500&height=400&seq=style-elegant-001&orientation=landscape',
      icon: 'ri-vip-crown-line'
    },
    {
      id: 5,
      name: 'Creativo',
      description: 'Único, artístico y original',
      image: 'https://readdy.ai/api/search-image?query=creative%20artistic%20logo%20design%20with%20hand%20drawn%20illustrations%2C%20colorful%20paint%20splashes%2C%20abstract%20artistic%20elements%2C%20imaginative%20unique%20concepts%2C%20playful%20experimental%20typography%2C%20vibrant%20mixed%20media%20textures%2C%20artistic%20studio%20aesthetic%2C%20creative%20energy%20and%20inspiration%2C%20watercolor%20effects%2C%20organic%20shapes%2C%20light%20neutral%20background%20showcasing%20artistic%20creativity&width=500&height=400&seq=style-creative-003&orientation=landscape',
      icon: 'ri-palette-line'
    },
    {
      id: 6,
      name: 'Juvenil',
      description: 'Fresco, dinámico y energético',
      image: 'https://readdy.ai/api/search-image?query=youthful%20energetic%20logo%20design%20with%20bright%20bold%20colors%2C%20playful%20fun%20typography%2C%20dynamic%20movement%2C%20fresh%20vibrant%20aesthetic%2C%20trendy%20pop%20culture%20style%2C%20energetic%20brand%20identity%2C%20young%20modern%20vibe%2C%20colorful%20gradient%20backgrounds%2C%20simple%20clean%20backdrop&width=500&height=400&seq=style-youthful-001&orientation=landscape',
      icon: 'ri-rocket-line'
    }
  ];

  const filteredStyles = activeFilter === 'Todos' 
    ? styles 
    : styles.filter(style => style.category === activeFilter);

  return (
    <section id="estilos" className="py-24 bg-gradient-to-b from-[#2d1b4e] via-[#1a0b2e] to-[#0f0520] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#ff00aa] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Estilos para cada personalidad
          </h2>
          <p className="text-xl text-[#c0c0ff]">
            Desde minimalista hasta premium, adaptamos nuestro diseño a tu visión
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-7 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeFilter === filter
                  ? 'bg-gradient-to-r from-[#ff00ff] to-[#00ffff] text-white shadow-lg shadow-[#ff00ff]/50'
                  : 'bg-[#1a0b2e]/50 backdrop-blur-sm border border-[#00ffff]/30 text-[#c0c0ff] hover:border-[#ff00ff]/50'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Masonry Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredStyles.map((style, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-2xl hover:scale-102 transition-transform duration-300 border border-[#00ffff]/20 hover:border-[#ff00ff]/50 hover:shadow-2xl hover:shadow-[#ff00ff]/30"
              style={{ height: index % 3 === 0 ? '400px' : index % 3 === 1 ? '350px' : '450px' }}
            >
              <img
                src={style.image}
                alt={style.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#ff00ff]/90 via-[#00ffff]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute top-4 left-4 bg-gradient-to-r from-[#ff00ff] to-[#00ffff] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg shadow-[#ff00ff]/50">
                {style.name}
              </div>
              <div className="absolute bottom-6 left-6 right-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <h3 className="text-2xl font-bold drop-shadow-lg">{style.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
